import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppLoggingService } from 'src/app/_shared/core/services/app-logging.service';
import { LoggerCommonService } from 'src/app/_shared/core/services/logger-common.service';

@Injectable({
  providedIn: 'root'
})
export class HandleErrorService {

  constructor(
    private readonly appLoggingService: AppLoggingService,
    private readonly logger: LoggerCommonService
  ) { }

  handleError(error: Error | HttpErrorResponse): string {
    this.logger.trace("HandleErrorService", "Error", null, error);
    if (error instanceof HttpErrorResponse) {
      this.appLoggingService.logException(error);
      const innerError = error.error.error;
      if (innerError?.details) {
          return innerError.details;
      } else {      
        if(error.status) {
          return innerError?.message;
        }
        return "Something went wrong"
      }
    }
    else {
      
      return "Something went wrong"
    }
  }

  handleSTSError(error: Error | HttpErrorResponse): string {
    this.logger.trace("HandleErrorService", "Error", null, error);
    if (error instanceof HttpErrorResponse) {
      this.appLoggingService.logException(error);
      const innerError = error.error;
      if (innerError.error_description) {
          return innerError.error_description;
      } else {    
        return "Something went wrong"
      }
    }
    else {
      
      return "Something went wrong"
    }
  }
}
